class BlogManager {
  constructor(posts, loadMoreBtn, increment = 3) {
    this.allPosts = posts;
    this.loadMoreBtn = loadMoreBtn;
    this.increment = increment;

    this.query = '';
    this.category = 'All';
    this.currentVisible = increment;
    this.matchedPosts = [];

    this.loadMoreBtn?.addEventListener('click', () => this.loadMore());
  }

  setQuery(query) {
    this.query = query.toLowerCase().trim();
    this.currentVisible = this.increment;
    this.applyFilters();
  }

  setCategory(category) {
    this.category = category;
    this.currentVisible = this.increment;
    this.applyFilters();
  }

  applyFilters() {
    this.matchedPosts = Array.from(this.allPosts).filter((post) => {
      const text = post.innerText.toLowerCase();
      const keywords = (post.getAttribute('data-keywords') || '').toLowerCase();
      const tags = post.getAttribute('data-tags') || '';
      const content = post.querySelector('.blog-articles__article-content')
        ? post.querySelector('.blog-articles__article-content').innerText.toLowerCase()
        : '';
      const matchesCategory = this.category === 'All' || tags.includes(this.category);
      const matchesSearch =
        this.query === '' || text.includes(this.query) || keywords.includes(this.query) || content.includes(this.query);

      return matchesCategory && matchesSearch;
    });

    this.render();
  }

  render() {
    this.allPosts.forEach((p) => (p.style.display = 'none'));

    this.matchedPosts.forEach((post, index) => {
      if (index < this.currentVisible) {
        post.style.display = 'block';
      }
    });

    this.loadMoreBtn.style.display = this.currentVisible >= this.matchedPosts.length ? 'none' : 'inline-flex';

    const noResults = document.getElementById('noResults');
    if (noResults) {
      noResults.style.display = this.matchedPosts.length === 0 ? 'block' : 'none';
    }
  }

  loadMore() {
    this.currentVisible += this.increment;
    this.render();
  }
}

class BlogSearch extends HTMLElement {
  constructor() {
    super();
    this.searchInput = null;
    this.searchBtn = null;
    this.resetBtn = null;
    this.manager = null;
  }

  connectedCallback() {
    this.searchInput = this.querySelector('#blogSearchInput');
    this.searchBtn = this.querySelector('#blogSearchBtn');
    this.resetBtn = this.querySelector('#blogResetBtn');
    this.resetBtn.style.display = 'none';

    const articles = document.querySelectorAll('.blog-articles__article');
    const loadMoreBtn = document.querySelector('#loadMoreBtn');

    // Shared BlogManager instance
    if (!window.blogManager) {
      window.blogManager = new BlogManager(articles, loadMoreBtn);
    }
    this.manager = window.blogManager;

    // "no results" message
    if (!document.getElementById('noResults')) {
      const template = document.getElementById('noResultsTemplate');
      const noResults = document.createElement('div');
      noResults.id = template.dataset.innerId;
      noResults.innerText = template.dataset.innerText;
      noResults.classList.add('blog-articles__article');
      noResults.style.textAlign = 'center';
      noResults.style.marginTop = '20px';
      noResults.style.display = 'none';

      document.querySelector('.blog-articles').appendChild(noResults);
    }

    this.bindEvents();
    this.manager.applyFilters(); // initial render
  }

  bindEvents() {
    this.searchInput?.addEventListener('input', () => {
      this.resetBtn.style.display = this.searchInput.value ? 'flex' : 'none';
    });

    this.searchBtn?.addEventListener('click', () => {
      this.manager.setQuery(this.searchInput.value);
    });

    this.resetBtn?.addEventListener('click', () => {
      this.searchInput.value = '';
      this.resetBtn.style.display = 'none';
      this.manager.setQuery('');
    });

    this.searchInput?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        this.manager.setQuery(this.searchInput.value);
      }
    });
  }
}

customElements.define('blog-search', BlogSearch);

class BlogFilter extends HTMLElement {
  constructor() {
    super();
    this.categoryRadios = [];
    this.viewResultsBtn = null;
    this.resetBtn = null;
    this.filterList = null;
    this.resultsButtons = null;
    this.toggleTitle = null;
    this.manager = null;
  }

  connectedCallback() {
    this.categoryRadios = document.querySelectorAll("input[name='blog_category']");
    this.viewResultsBtn = this.querySelector('.blog-list__results-text');
    this.resetBtn = this.querySelector('.blog-list__reset');
    this.filterList = this.querySelector('.blog-list__blog-filter');
    this.resultsButtons = this.querySelector('.blog-list__results');
    this.toggleTitle = this.querySelector('.blog-list__filter-title');

    const articles = document.querySelectorAll('.blog-articles__article');
    const loadMoreBtn = document.querySelector('#loadMoreBtn');

    if (!window.blogManager) {
      window.blogManager = new BlogManager(articles, loadMoreBtn);
    }
    this.manager = window.blogManager;

    this.bindEvents();
    this.manager.applyFilters(); // initial view
  }

  bindEvents() {
    this.viewResultsBtn?.addEventListener('click', () => {
      const selected = document.querySelector("input[name='blog_category']:checked");
      if (selected) this.manager.setCategory(selected.value);
    });

    this.resetBtn?.addEventListener('click', () => {
      document.getElementById('cat-all').checked = true;
      this.manager.setCategory('All');
    });

    // Mobile toggle
    this.toggleTitle?.addEventListener('click', () => {
      if (window.innerWidth <= 768) {
        this.toggleFilterMobile();
      }
    });
  }

  toggleFilterMobile() {
    if (!this.filterList || !this.resultsButtons) return;

    this.filterList.classList.toggle('is-open');
    this.resultsButtons.classList.toggle('is-open');
    this.toggleTitle.classList.toggle('rotate');

    [this.filterList, this.resultsButtons].forEach((el) => {
      if (el.classList.contains('is-open')) {
        el.style.maxHeight = el.scrollHeight + 'px';
      } else {
        el.style.maxHeight = 0;
      }
    });
  }
}

customElements.define('blog-filter', BlogFilter);
